import axios from 'axios';

// Use Vite dev proxy by default to avoid CORS in development.
// If VITE_API_URL is set, it will override and be used as an absolute URL.
export const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api',
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
});

// Request interceptor: attach auth token + handle FormData
apiClient.interceptors.request.use(
  (config) => {
    // Attach the session token (unless the caller already set an Authorization header)
    const token = localStorage.getItem('textflow_auth_token');
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // If the request data is FormData, remove the Content-Type header
    // so axios can set it automatically with the correct boundary
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor: on 401, clear the session and force re-login
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const onLoginPage = window.location.pathname === '/login';
      const hadToken = !!localStorage.getItem('textflow_auth_token');
      // Only bounce to login if we actually had a session that just got rejected,
      // to avoid loops on the login page itself.
      if (hadToken && !onLoginPage) {
        localStorage.removeItem('textflow_auth_token');
        localStorage.removeItem('textflow_user_data');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;


